window.splitStringPrice = function(stringPrice) {
  const digitIndex = stringPrice.search(/\d/);
  const priceUnit = stringPrice.slice(0, digitIndex);
  const priceDigit = stringPrice.slice(digitIndex);

  const price = parseFloat(priceDigit.replace(',', ''));

  return [priceUnit, price];
}

window.updateItem = async function(data) {

  const itemPriceUI = document.getElementById(`item-price-ui-${data.line}`)
  const loaderUI = document.getElementById(`price-loader-${data.line}`)
  const itemQtyMultipy = document.getElementById(`item-qty-multiply-${data.line}`)

  loaderUI.classList.remove('hidden');
  loaderUI.classList.add('flex');

  itemPriceUI.classList.remove('flex');
  itemPriceUI.classList.add('hidden');

  const xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/change.js', true);
  xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
  xhr.onload = function () {
    if (this.status == 200) {
      console.log("data: ", data);

      const priceUI = document.getElementById(`item-price-${data.line}`)
      let unitPrice = priceUI.getAttribute('data-unit-price');

      const [priceUnit, price] = splitStringPrice(unitPrice);

      priceUI.innerHTML = `${priceUnit}${(data.quantity * price).toLocaleString('en-IN')}`;

      const lineItemPrices = document.getElementsByClassName('item-prices');
      let subTotal = 0;
      for (const itemPrice of lineItemPrices) {
        const [unit, priceNum] = splitStringPrice(itemPrice.innerText);
        subTotal += priceNum;
      }

      const discountPriceElem = document.getElementById('discount-price');
      const discountValue = discountPriceElem.dataset.discountValue;
      const discountType = discountPriceElem.dataset.discountType;
      const discountPrice = (discountType == "percentage" ? (subTotal * discountValue / 100) : discountValue);
      discountPriceElem.innerHTML = `${priceUnit}${discountPrice.toLocaleString('en-IN')}`

      const discountedPrice = subTotal - discountPrice;

      const totalPriceElem = document.getElementById('total-price');
      totalPriceElem.innerHTML = `${priceUnit}${discountedPrice.toLocaleString('en-IN')}`
      itemQtyMultipy.innerHTML = data.quantity.toLocaleString('en-IN');

      const lineItemQuantities = document.getElementsByClassName('line-item-quantity');
      let cartCount = 0;
      for (const quantity of lineItemQuantities) {
        const qty = parseInt(quantity.value);
        cartCount += qty;
      }

      document.getElementById('subtotal-price').innerHTML = `${priceUnit}${subTotal.toLocaleString('en-IN')}`
      for (const totalElem of document.getElementsByClassName('total-price')) {
        totalElem.innerHTML = `${priceUnit}${discountedPrice.toLocaleString('en-IN')}`;
      }
      document.getElementById('cart-count').innerHTML = cartCount;

      loaderUI.classList.add('hidden');
      loaderUI.classList.remove('flex');

      itemPriceUI.classList.add('flex');
      itemPriceUI.classList.remove('hidden');
    }
  }
  xhr.send(JSON.stringify(data));
}

window.updateItemByLine = function(line, newQty) {
  const ind = line - 1;

  const oldQty = cartInfo[ind]['quantity'];
  const newQtyInt = parseInt(`${newQty}`);
  const qtyDiff = newQtyInt - oldQty;
  const qtySign = Math.sign(qtyDiff);

  const qtyUpdatedBy = Math.abs(qtyDiff);

  cartInfo[ind]['quantity'] = newQtyInt

  if (qtySign == 1) {
    pushAddToCart(cartInfo[ind], qtyUpdatedBy)
  } else if (qtySign == -1) {
    pushRemoveFromCart(cartInfo[ind], qtyUpdatedBy)
  }

  return updateItem({
    line: line,
    quantity: newQty
  });
}

window.isAllItemsQtyZero = function() {
  const lineItemQuantities = document.getElementsByClassName('line-item-quantity');

  for (const item of lineItemQuantities) {
    if (item.value > 0) {
      return false;
    }
  }

  return true;
}

window.changeQuantity = function(id, func) {
  const itemQty = document.getElementById(id);
  const itemQtyVal = parseInt(itemQty.value);
  let lineNo = id.replace("Quantity-", "");
  lineNo = parseInt(lineNo);


  if (func == "+") {
    itemQty.value = itemQtyVal + 1;
  } else {

    if (itemQtyVal == 0) return
    itemQty.value = itemQtyVal - 1;
  }

  if (itemQty.value == 0) {
    if (isAllItemsQtyZero()) {
      setTimeout(function () {
        location.reload()
      }, 500)
    } else {
      document.getElementById(`item-row-${lineNo}`).style.display = "none"
    }
  }

  updateItemByLine(lineNo, itemQty.value);
}

window.removeFromCart = function(event, line, url_to_remove) {
  event.preventDefault();
  const itemPriceUI = document.getElementById(`item-price-ui-${line}`)
  const loaderUI = document.getElementById(`price-loader-${line}`)

  itemPriceUI.classList.remove('flex');
  itemPriceUI.classList.add('hidden');

  updateItemByLine(line, 0);

  loaderUI.classList.remove('hidden');
  loaderUI.classList.add('flex');


  setTimeout(() => location.reload(), 1000);
}